import styled from "styled-components"
import { Popover } from "react-bootstrap"

export interface PopoverRowProps {
    listStyle?: boolean
}

export const PopoverWrapper = styled.div`
    width: 100%;
    cursor: pointer;
`
export const PopoverStyled = styled(Popover)<{
    placement: "left" | "right"
}>`
    background: ${(props) => props.theme.tablePopoverBackground};

    & > .popover-arrow {
        margin: 0;
    }

    & > .popover-arrow::before,
    & > .popover-arrow::after {
        border-left-color: ${(props) => (
        props.placement === "left"
            ? props.theme.tablePopoverBackground
            : "transparent")};
        border-right-color: ${(props) => (
        props.placement === "right"
            ? props.theme.tablePopoverBackground
            : "transparent")};
    }
`
export const PopoverContentStyled = styled(Popover.Body)`
    padding-left: 30px;
    color: ${(props) => props.theme.tablePopoverColor};
`
export const PopoverContentRow = styled.div<PopoverRowProps>`
    display: ${(props) => (props.listStyle ? "list-item" : "block")};
    transform: ${(props) => (props.listStyle ? "none" : "translateX(-10px)")};
`
export const PopoverTitleWrapper = styled.div`
    display: flex;
    width: 100%;

    i {
        display: flex;
        align-items: center;
        margin-left: 10px;
        opacity: 0;
        color: grey;
        transition: opacity ${(props) => props.theme.defaultTransition};
    }

    &:hover {
        i {
            opacity: 1;
            transition: opacity ${(props) => props.theme.defaultTransition};
        }
    }
`
export const PopoverTitle = styled.span`
    max-width: calc(100% - 22px);
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
`
